// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__mUSCS","footer":"ReportModalFilter_footer__3dQhl"};